import configurationApi from '../api/configurationApi';

export default {
    namespaced: true,
    state: {
        sprayConfigurations : []
    },
    getters: {
        getSprayConfigurations(state) {
            if(state.sprayConfigurations) {
                return state.sprayConfigurations;
            }
            return [];
        }
    },
    mutations: {
        updateSprayConfigurations(state, value) {
            state.sprayConfigurations = value;
        }
    },
    actions: {
        async loadSprayConfigurations({ commit }) {
            let sprayConfigurations = await configurationApi.getSprayConfigurations();
            commit('updateSprayConfigurations', sprayConfigurations);
        },
        async saveSprayConfiguration({commit}, spray) {
            if(spray.Editing) {
                let result  = await configurationApi.updateSprayConfiguration(spray);
                if(result.Success == true) {
                    commit('updateSprayConfigurations', result.Spraies);
                } else {
                    return result;
                }
            } else {
                let result  = await configurationApi.addSprayConfiguration(spray);
                if(result.Success == true) {
                    commit('updateSprayConfigurations', result.Spraies);
                } else {
                    return result;
                }
            }
        }
    }
}